<div *ngIf="isFirstOrder$ | async" class="ior-container">
    <div class="ior-title" translate="cart.checkout.ior.title"></div>
    <div class="ior-message">
        <i class="fa-solid fa-sparkles margin-right-8"></i>
        <ng-container *ngIf="!!iorSaveMessageTranslation; else noIor">
            <span [innerHTML]="iorSaveMessageTranslation"></span>
            <a class="ior-learn-more d-block"
               [popover]="learnMorePopover"
               triggers="focus"
               [adaptivePosition]="false"
               placement="bottom"
               tabindex="0"
               containerClass="ior-popover ">{{"cart.checkout.ior.learn.more" | translate}}</a>
        </ng-container>
        <ng-template #noIor>
            <span translate="cart.checkout.no.ior.discount"></span>
        </ng-template>
    </div>
</div>

<ng-template #learnMorePopover>
    <div class="popover-message">
        <div [innerHTML]="learnMoreTranslation"></div>
    </div>
</ng-template>
